import { useTranslation } from 'react-i18next'

import { InputField } from '../../../Input'
import { ENTITY_TAB_POSTS_SEARCH_MAX_LENGTH } from '../EntityTabPosts.constants'

import { QA_NAME_ENTITY_TAB_POSTS_SEARCH } from './EntityTabPostsSearch.constants'

import * as styles from './EntityTabPostsSearch.module.css'

import SearchIcon from '../../../../icons/search.svg'

function EntityTabPostsSearch({ value, onChange, onClear }) {
  const { t } = useTranslation()

  return (
    <InputField
      afterIconProps={{
        Icon: SearchIcon,
      }}
      maxLength={ENTITY_TAB_POSTS_SEARCH_MAX_LENGTH}
      placeholder={t('Common.SearchPlaceholderKey')}
      qaName={QA_NAME_ENTITY_TAB_POSTS_SEARCH}
      showError={false}
      value={value}
      wrapperClassName={styles.search}
      onChange={onChange}
      onClear={onClear}
    />
  )
}

export default EntityTabPostsSearch
